import { apiService } from "../app/api";
import { handleAxiosError } from "../helper/errorHandler";

const SESSION_KEY = "active_languages";

/**
 * Fetch active languages with sessionStorage cache
 */
export const fetchLanguages = async (): Promise<string[]> => {
  try {
    const cached = sessionStorage.getItem(SESSION_KEY);
    if (cached) {
      return JSON.parse(cached);
    }

    const { data } = await apiService.get("/languages", {
      params: {
        is_active: true,
        page: 1,
        limit: 100,
        fields: "language",
      },
    });

    const languages: string[] =
      data?.data?.map((item: { language: string }) => item.language) || [];

    sessionStorage.setItem(SESSION_KEY, JSON.stringify(languages));

    return languages;
  } catch (error: any) {
    handleAxiosError(error);
    return [];
  }
};
